import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is StemWave acoustic wave therapy?",
  answer: "StemWave is an advanced acoustic wave therapy that uses sound waves to stimulate the body's natural healing processes, reducing inflammation and promoting tissue repair without surgery or downtime."
}, {
  question: "What are your clinic's operating hours?",
  answer: "We are available to serve our patients Monday through Friday from 9:00 AM to 5:00 PM, and Saturdays from 10:00 AM to 1:00 PM. We are closed on Sundays to allow our staff time with their families."
}, {
  question: "Do I need an appointment for a walk-in visit?",
  answer: "No appointment is necessary for urgent care or basic primary care needs. However, we encourage you to book online to minimize your wait time and streamline the check-in process upon your arrival."
}, {
  question: "Where is Dr. Kaszuba's Primary Care located?",
  answer: "Our clinic is conveniently located at 1803 Briar Creek Blvd, Safety Harbor, FL 34695. We offer ample parking and a professional, welcoming environment for all our patients."
}, {
  question: "What medical services do you provide?",
  answer: "We offer a full range of services including treatment of acute/chronic pain with medications and cortisol injections, Acoustic Wave Therapy tailored to your health needs."
}, {
  question: "Do you accept my health insurance plan?",
  answer: "We accept most major insurance providers. To ensure a smooth visit, please bring your insurance card and a valid photo ID. Our staff can help verify your coverage during your check-in."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="222051" id="patient-essentials" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto mt-20 px-4 md:mt-0 md:px-6 max-w-4xl">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary md:text-4xl">
            Patient Essentials
          </h2>
          <p className="font-default mx-auto mt-4 max-w-2xl text-lg text-muted-foreground">
            Find answers to common questions about our Safety Harbor clinic, from hours of operation to insurance and walk-in procedures.
          </p>
        </div>

        <div className="rounded-3xl border border-border bg-card p-6 shadow-xl md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                <AccordionTrigger className="group py-5 hover:no-underline [&>svg:last-child]:hidden">
                  <span className="font-default text-left text-lg font-semibold text-primary">
                    {faq.question}
                  </span>
                  <span className="shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45">
                    <Plus className="size-5 text-ring" />
                  </span>
                </AccordionTrigger>
                <AccordionContent className="font-default pr-12 pb-5 text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}